import loadable from '@loadable/component';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const MainSearchPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "MainSearchPageContainer" */
      './MainSearchPageContainer.dynamic'
    ),
  { fallback: <LoadableLoadingSection /> },
);
